





































import { ROUTE_WORKFLOW_ADD } from '@/areas/claims/claims-routes';
import OtInviteUserDialog, { InviteUserDialogParams } from '@/areas/invitations/ot-invite-user-dialog.vue';
import { AconexImportDialogParams } from '@/components/documents/aconex-import-dialog/aconex-import-dialog-models';
import {
  AddEditDialogMode,
  AddEditDocumentDialogParams,
} from '@/components/documents/add-edit-document-dialog/add-edit-document-dialog-models';
import { SelectDocumentDialogParams } from '@/components/documents/select-document-dialog/select-document-dialog-models';
import OtStandardHeaderArchetype from '@/components/global/archetypes/ot-standard-header-archetype.vue';
import { IInputAction, IInputTab } from '@/components/global/common-models';
import OtLoadingSpinner from '@/components/global/ot-loading-spinner.vue';
import OtTabs from '@/components/global/ot-tabs.vue';
import OtTag, { TagStatus } from '@/components/global/ot-tag.vue';
import { SnackbarItem, SnackbarTypeEnum } from '@/components/global/snackbar/snackbar-models';
import { doAconexImport } from '@/services/aconex.service';
import OtApi, { executeApi } from '@/services/api.service';
import { PostUpdateDocumentAssociationsRequestModel } from '@/services/generated/api';
import { vxm } from '@/store';
import {
  CONTRACT_STATUSES_CAN_CREATE_CLAIMS_FOR,
  OtContractStatus,
  OtStatusType,
  OtUserStatus,
  PROJECT_STATUSES_CANNOT_CREATE_CLAIMS_FOR,
} from '@/types/status-enums';
import { areSame } from '@/utils/string-utils';
import { Component, Ref, Vue, Watch } from 'vue-property-decorator';
import { ProjectDetails } from '../project-models';
import { ROUTE_PROJECT_DEFAULT } from '../projects-routes';
import { ContractDetails } from './contract-models';
import {
  ROUTE_CONTRACT_DASHBOARD,
  ROUTE_CONTRACT_DOCUMENTS,
  ROUTE_CONTRACT_USERS,
  ROUTE_CONTRACT_WORKFLOWTYPES,
} from './contract-routes';
import { ContractUser } from './contract-user-models';

@Component({
  components: {
    OtLoadingSpinner,
    OtStandardHeaderArchetype,
    OtTabs,
    OtTag,
    OtInviteUserDialog,
  },
})
export default class OtContractsLayout extends Vue {
  // * PROPS

  // * REFS

  // * DATA
  private newClaimButton: IInputAction = {
    actionName: 'New Workflow',
    action: { name: ROUTE_WORKFLOW_ADD, query: { project: this.projectGid, contract: this.contractGid } },
  };
  private newUserButton: IInputAction = {
    actionName: 'New User',
    action: () => this.createNewUser(),
  };
  private newDocumentButton: IInputAction = {
    actionName: 'New Document',
    action: () => this.createNewDocument(),
  };
  private importDocumentButton: IInputAction = {
    actionName: 'Add Existing Document',
    action: () => this.importDocument(),
  };
  private importFromAconexButton: IInputAction = {
    actionName: 'Import From Aconex',
    action: () => this.importFromAconex(),
  };

  private get currentRouteName() {
    return this.$route.name;
  }

  private get primaryContextBtn() {
    switch (this.currentRouteName) {
      case ROUTE_CONTRACT_USERS:
        return this.newUserButton;
      case ROUTE_CONTRACT_DOCUMENTS:
        return this.newDocumentButton;
      default:
        return this.newClaimButton;
    }
  }

  private get secondaryContextBtns() {
    switch (this.currentRouteName) {
      case ROUTE_CONTRACT_DOCUMENTS:
        return [this.importDocumentButton, this.importFromAconexButton];
      default:
        return [];
    }
  }

  private viewContractTabs: IInputTab[] = [
    {
      tabId: 0,
      tabText: 'Workflows',
      tabRoute: {
        name: ROUTE_CONTRACT_DASHBOARD,
      },
    },
    {
      tabId: 1,
      tabText: 'Contract Details',
      tabRoute: {
        name: 'ContractDetails',
      },
    },
    {
      tabId: 2,
      tabText: 'Workflow Types',
      tabRoute: {
        name: ROUTE_CONTRACT_WORKFLOWTYPES,
      },
    },
    {
      tabId: 3,
      tabText: 'Documents',
      tabRoute: {
        name: 'ContractDocuments',
      },
    },
    {
      tabId: 4,
      tabText: 'Users',
      tabRoute: {
        name: 'ContractUsers',
      },
    },
  ];

  private baseFormContractTabs: IInputTab[] = [
    {
      tabId: 0,
      tabText: 'Contract Details',
      tabRoute: {
        name: 'EditContractDetails',
      },
    },
  ];

  private api = new OtApi();
  private loading = false;

  private contractDetails: ContractDetails | null = null;
  private projectDetails: ProjectDetails | null = null;
  private contractUsers: ContractUser[] = [];

  // * COMPUTED
  private get routePath(): string | null {
    return this.$route.path || null;
  }

  private get contractName(): string {
    return this.contractDetails?.name || '';
  }

  private get currentUserIsActiveOrgUser() {
    return this.projectDetails?.organisationUser?.status === OtUserStatus.Active;
  }
  private get currentUserIsActiveProjectUser() {
    return this.projectDetails?.projectUser?.status === OtUserStatus.Active;
  }

  /* yeah, nah, this method should exist, but we can't work it out, see comments
  private get currentUserIsActiveContractUser() {
    // nope, there's no contract gid here
    // return this.projectDetails?.contractUsers.some(x => x.).
    // nope, we don't load the contract user here
    // return this.contractDetails.contractUser
    // could infer true by if they're not an active org or project they MUST be an active contract user
    // but that's not transitive, they could be a project and a contract user, we don't want to return false just because they're an active project or org user
    // so, to answer the question: I don't know
    return dunno;
  }
  */

  private get isContextBtnDisabled(): boolean {
    // never possible in form state. Whatever that is.
    if (this.isInFormState) {
      return true;
    }
    // no project or contract, no primary button for you
    if (!this.contractDetails || !this.projectDetails) {
      return true;
    }
    // special case the user tab
    if (this.currentRouteName === ROUTE_CONTRACT_USERS) {
      // this ideally should be disabled if the current user is not an org user or a project user
      // but it's not in the spec
      return false;
    }
    // another special case for the documents tab
    if (this.currentRouteName === ROUTE_CONTRACT_DOCUMENTS) {
      // spec says to check project/contract/org user here
      // but really, if you're looking at the contract, you're a project/contract/org user anyway
      // so I (Dan) am just going to skip those checks
      // Partly because they're not needed
      // but mostly because we can't work out if the user is an active contract user or not - see commented out currentUserIsActiveContractUser
      // spec says to do the same checks as for creating a claim. Yeah, these say CAN CREATE CLAIM not CAN ADD DOCUMENT but they'll do
      return (
        !CONTRACT_STATUSES_CAN_CREATE_CLAIMS_FOR.includes(this.contractDetails.status) ||
        PROJECT_STATUSES_CANNOT_CREATE_CLAIMS_FOR.includes(this.projectDetails.status)
      );
    }

    // precision of language would be good. We specc'd contrac statuses you can create for, but project you cannot create for. D'oh
    return (
      !CONTRACT_STATUSES_CAN_CREATE_CLAIMS_FOR.includes(this.contractDetails.status) ||
      PROJECT_STATUSES_CANNOT_CREATE_CLAIMS_FOR.includes(this.projectDetails.status)
    );
  }

  private get isInFormState(): boolean {
    const routeName = this.currentRouteName || '';
    const formRouteNames = this.formContractTabs.map(t => t.tabRoute?.name || '');
    return formRouteNames.includes(routeName);
  }

  private get formContractTabs(): IInputTab[] {
    return [...this.baseFormContractTabs];
  }

  private get contractTabs(): IInputTab[] {
    if (this.isInFormState) {
      return this.formContractTabs;
    }
    return this.viewContractTabs;
  }

  private get projectGid(): string {
    return this.$route.params.projectGid;
  }

  private get contractGid(): string {
    return this.$route.params.contractGid;
  }

  // * WATCHERS
  @Watch('routePath')
  private async checkRoutePath() {
    this.loading = true;
    const apiCalls: Promise<void>[] = [];

    // Since this function will get called any time the user selects a new tab,
    // we only need to load the data if it hasn't already been loaded
    if (this.contractDetails === null || !areSame(this.contractDetails.gid, this.contractGid)) {
      apiCalls.push(this.handleReloadContractDetails());
    }
    if (this.projectDetails === null || !areSame(this.projectDetails.gid, this.projectGid)) {
      apiCalls.push(this.getProjectDetails());
    }

    await Promise.all(apiCalls);

    // They cannot come to anything in this layout for DRAFT contracts
    // We'll put the "cannot edit it" check inside the form itself
    if (this.contractDetails?.status === OtContractStatus.Draft) {
      vxm.snackbar.addToSnackbarQueue(
        new SnackbarItem({
          type: SnackbarTypeEnum.Error,
          message: 'You cannot view a draft contract using this view',
        }),
      );
      this.$router.push({
        name: ROUTE_PROJECT_DEFAULT,
        params: { projectGid: this.projectGid },
      });
      this.loading = false;
      return;
    }

    if (this.currentRouteName === ROUTE_CONTRACT_USERS && !this.contractUsers?.length) {
      this.loading = true;
      await this.handleReloadContractUsers();
      this.loading = false;
    }

    this.loading = false;
  }

  // * METHODS
  private async handleReloadContractDetails(callback?: () => void) {
    if (this.contractGid) {
      const result = await executeApi(
        () => this.api.contracts().getContractDetails(this.contractGid),
        'Load Contract Details',
      );
      if (result.success && result.data && result.data.contract) {
        this.contractDetails = ContractDetails.createFromApiResponse(result.data.contract);
        vxm.breadcrumbs.setContractName({ contractName: this.contractDetails.name });
      }
    }

    if (callback) {
      callback();
    }
  }

  private async handleReloadContractUsers(callback?: () => void) {
    const result = await executeApi(
      () => this.api.contracts().getContractUsers(this.contractGid),
      'Load Contract Users',
    );
    if (result.success && result.data) {
      this.contractUsers = result.data?.users?.map(user => ContractUser.createFromApiResponse(user));
    }
    if (callback) {
      callback();
    }
  }

  private async getProjectDetails() {
    if (this.projectGid) {
      const result = await executeApi(
        () => this.api.projects().getProjectDetails(this.projectGid),
        'Load Project Details',
      );
      if (result.success && result.data) {
        this.projectDetails = ProjectDetails.createFromApiResponse(result.data);
        vxm.breadcrumbs.setProjectName({ projectName: this.projectDetails.name });
      }
    }
  }

  private getTagStatus(status: OtContractStatus): TagStatus {
    return { type: OtStatusType.Contract, status };
  }

  @Ref('inviteUserDialogRef')
  private readonly inviteUserDialogRef!: OtInviteUserDialog;

  private async createNewUser() {
    if (!this.contractDetails) return;

    const params = new InviteUserDialogParams({
      isReinvite: false,
      organisationGid: this.contractDetails.organisationGid,
      inviteToOrganisation: false,
      contracts: [this.contractDetails.gid],
    });

    const dialogResult = await this.inviteUserDialogRef.open(params);
    if (dialogResult) {
      this.handleReloadContractUsers();
    }
  }

  private dodgyHackToReloadCurrentView = 1;

  private async createNewDocument() {
    const params = new AddEditDocumentDialogParams({
      addToOrganisation: false,
      targetOrganisationGid: this.contractDetails?.organisationGid,
      addToContractGids: [this.contractGid],
      context: 'Contract',
      mode: AddEditDialogMode.Create,
    });
    const result = await vxm.modal.openAddEditDocumentDialog(params);
    if (result.ok) {
      // the documents tab does its own loading. We can't just call handleReloadDocuments here, because it doesn't exist
      // we could somehow pulse a signal down (update a Symbol) that could be watched, but meh
      // we could allow the child to register an onReloadDocuments handler by emitting a setReloadDocuments event, hold it, call it here, but meh
      // incrementing a variable to reload the whole shooting match works well enough.
      // Unfortunately it blows away the search criteria, that might be annoying.
      // If the user is sitting there with a list of 5 documents to create, all with a reference ABC123-something, and they search
      // for ABC-123 to see what needs creating
      // it might be beneficial to retain the search results. If that turns out to be a wanted feature, consider the setReloadDocuments event
      this.dodgyHackToReloadCurrentView = this.dodgyHackToReloadCurrentView + 1;
    }
  }

  private async importDocument() {
    if (!this.contractDetails?.organisationGid) return;

    const params = new SelectDocumentDialogParams({
      targetOrganisationGid: this.contractDetails?.organisationGid,
      context: 'Contract',
    });
    const dialogResult = await vxm.modal.openSelectDocumentDialog(params);
    if (dialogResult.ok) {
      for (const selectedDocument of dialogResult.selectedDocuments) {
        const request = new PostUpdateDocumentAssociationsRequestModel({
          addProjectAssociations: [],
          addContractAssociations: [this.contractGid],
          addOrganisationAssociations: [],
          removeProjectAssociations: [],
          removeContractAssociations: [],
          removeOrganisationAssociations: [],
        });
        await executeApi(
          () => this.api.documents().postUpdateDocumentAssociations(selectedDocument.gid, request, undefined),
          'Associate Document with Contract',
        );
      }
      this.dodgyHackToReloadCurrentView = this.dodgyHackToReloadCurrentView + 1;
    }
  }
  private async importFromAconex() {
    const params = new AconexImportDialogParams({
      documentParams: new AddEditDocumentDialogParams({
        addToOrganisation: false,
        targetOrganisationGid: this.contractDetails?.organisationGid,
        addToContractGids: [this.contractGid],
        context: 'Contract',
        mode: AddEditDialogMode.Create,
      }),
    });
    const result = await doAconexImport(params);
    if (result.didImport) {
      this.dodgyHackToReloadCurrentView = this.dodgyHackToReloadCurrentView + 1;
    }
  }
  // * LIFECYCLE
  private async created() {
    await this.checkRoutePath();
  }
}
